import * as Cookies from 'js-cookie';

function converter() {}

function decode(s) {
  return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
}

/**
 * Replacement cookie getter function that deals with multiple spaces separating cookies,
 * which breaks the default js-cookie parser.
 * @param {string} [key] - the name of the cookie requested. If omitted, all cookies are returned as an object.
 * @param {boolean} [json] - true if json decoding is required; otherwise false.
 * @return {*}
 */
function getCookie(key, json = false) {
  if (typeof window === 'undefined' || typeof window.document === 'undefined') {
    return;
  }

  const jar = {};
  // To prevent the for loop in the first place assign an empty array
  // in case there are no cookies at all.
  const cookies = document.cookie ? document.cookie.split(/;\s+/) : [];
  let i = 0;

  // eslint-disable-next-line no-plusplus
  for (; i < cookies.length; i++) {
    const parts = cookies[i].split('=');
    let cookie = parts.slice(1).join('=');

    if (!json && cookie.charAt(0) === '"') {
      cookie = cookie.slice(1, -1);
    }

    try {
      const name = decode(parts[0]);
      cookie = (converter.read || converter)(cookie, name)
        || decode(cookie);

      if (json) {
        try {
          cookie = JSON.parse(cookie);
        } catch (e) {
          // Couldn't find the cookie.
        }
      }

      jar[name] = cookie;

      if (key === name) {
        // this is the cookie used by trackers to ensure we do not fire multiple events for the same purchase
        // for Shopify checkouts, the cookie is first dropped on the checkout page, then on the PPO upsell page (if the
        // customer accepts an upsell); the PPO upsell code lives in an iFrame and thus rather than update the existing
        // cookie, it drops a new cookie, resulting in two cookies
        // so the TL;DR: we need to combine the two cookies to ensure we have a record of all the purchase events sent
        // note, only doing this for the one cookie i know is affected...
        if (key === 'uids') {
          jar[name] = {...cookie};
        } else {
          break;
        }
      }
    } catch (e) {
      // Couldn't find the cookie.
    }
  }

  // eslint-disable-next-line consistent-return
  return key ? jar[key] : jar;
}

const BTCookies = {
  ...Cookies,
  get: key => {
    return getCookie(key, false);
  },
  getJSON: key => {
    return getCookie(key, true);
  },
};

export default BTCookies;
